module.exports = {
    stockChecker: {
        modalTitle: 'Check stock in our stores',
        modalDisclaimer: 'Stock levels updated every 2 hours',
        productPageLinkText: 'Check stock in our stores',
        showOnProductPage: false,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/stock-checker.js